import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SectionTitleStyled = styled.h2`
  font-size: 2.4rem;
  line-height: 3.2rem;
  letter-spacing: 0.02em;
  margin: 0 0 1rem;
  padding-bottom: 1.6rem;
  color: ${colors.neutral[900]};
  border-bottom: 1px solid ${colors.neutral[300]};
`;

export const SectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  padding: 4rem 5rem 8rem;
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  min-height: 20rem;

  &:last-child {
    margin-top: 6rem;
  }
`;
